import { defineComponent } from 'vue';
import ActReviewAndConfirmCode from '@/presentation/components/act-access-modal/act-review-and-confirm/act-review-and-confirm.code';

export default defineComponent({
	setup: () => {
		const code = new ActReviewAndConfirmCode();

		return {
			relevantActAccessEntry: code.relevantActAccessEntry,
			actUsersToAddAsString: code.actUsersToAddAsString,
			actUsersToAdd: code.actUsersToAdd,
			actDashboardsToAddAsString: code.actDashboardsToAddAsString,
			actDashboardsToAdd: code.actDashboardsToAdd,
			sameDatesPerDashboard: code.sameDatesPerDashboard,
			actDashboardsToShowDatesFor: code.actDashboardsToShowDatesFor,
			transformDateObjectToUTCDateString: code.transformDateObjectToUTCDateString.bind(code)
		};
	}
});
